module.exports = __webpack_public_path__ + "img/5.fdce3342.jpg";